<template>
    <div class="w-full h-full overflow-hidden m-0 p-0">
		<div class="flex w-full h-full justify-content-center align-items-center pt-0 pb-0 xl:pt-4 xl:pb-8 lg:pt-3 lg:pb-5 md:pt-3 md:pb-5">
			<div class="flex flex-column w-full h-full surface-0 xl:border-round-xl lg:border-round-xl overflow-scroll"> 
                <span v-if="header" class="text-900 font-medium p-3
                    text-2xl xl:text-5xl lg:text-4xl md:text-3xl
                    mb-0 xl:mb-4 lg:mb-3 md:mb-2 sm:mb-2
                    flex xl:flex lg:flex md:flex">
                    {{ header }}
                </span>
                <!--Page body start-->
                <slot name="body"></slot>
                <!--Page body end-->
			</div>
		</div>
	</div>
</template>

<script>
export default {
    props: ['header'],
    data() {
        return {
            
        }
    }
}
</script>
